export default __webpack_public_path__ + "static/media/5.369a6944.jpg";